var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top"},[_c('Header'),_c('Start')],1),_c('Services'),_c('About'),_c('Certificates'),_c('Charity'),_c('Contact'),_c('Footer'),_c('Cookie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }